import React from "react";
import {ShaderGradient, ShaderGradientCanvas} from "shadergradient";

const ShaderGradientComponent = () => {
    return (
        <div className="ShaderGradient">
            <div className="mask"></div>
            <ShaderGradientCanvas>
                <ShaderGradient
                  color1="#057CFF"
                  color2="#81BDFF"
                  color3="#80b9ff"
                  type="waterPlane"
                  uFrequency={0.5}
                  uStrength={3}
                  uSpeed={0.4}
                  brightness={1.2}
                  envPreset="city"
                  rotationX={0}
                  rotationY={0}
                  rotationZ={0}
                  lightType="2d"
                  grain="off"
                  cDistance={2}
                  fov={10}
                />
            </ShaderGradientCanvas>
        </div>
    );
};

export default ShaderGradientComponent;
